<template>
  <div class="base-setup">
    <a-form
      ref="baseSetting"
      :form="form"
      :model="setup"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-item label="表单名称">
        <a-input placeholder="请输入表单名称" v-decorator="['formName', { rules: [{ required: true, message: '请输入表单名称' }]}]"/>
      </a-form-item>
      <a-form-item label="所在分组" class="group" prop="groupId" v-if="false">
        <a-select style="width: 70%; margin-right: 10px" placeholder="请选择分组" v-decorator="['groupId', { rules: [{ required: true, message: '请输入表单名称' }]}]">
          <a-select-option
            v-for="(op, index) in fromGroup"
            :key="op.id"
            v-show="op.id > 0 && index > -1">
            {{ op.name }}
          </a-select-option>
        </a-select>
        <a-popover title="新建流程模板分组" width="600" trigger="click">
          <a-row slot="content">
            <a-col :span="17">
              <a-input v-model="newGroup" placeholder="请输入新的分组名" />
            </a-col>
            <a-col :span="5" offset="1">
              <a-button type="primary" @click="addGroup">提交</a-button>
            </a-col>
          </a-row>
          <a-button icon="plus" type="primary">新建分组</a-button>
        </a-popover>
      </a-form-item>
      <a-form-item label="所属分类">
        <a-cascader
          v-decorator="['category', { rules: [{ required: true, message: '请选择所属分类' }]}]"
          :options="filterCategories"
          expand-trigger="hover"
          placeholder="请选择分类"
          @change="onChange" />
      </a-form-item>
      <a-form-item label="表单说明">
        <a-textarea
          v-decorator="['remark', { rules: [{ required: false, message: '请选择所属分类' }]}]"
          placeholder="请输入表单说明"
          type="textarea"
          show-word-limit
          :autosize="{ minRows: 2, maxRows: 4}"
          :maxLength="256"></a-textarea>
      </a-form-item>
    </a-form>
    <dept-picker
      v-if="pickVisible"
      title="请选择可以管理此表单的人员"
      multiple
      ref="orgPicker"
      :selected="select"
      @ok="selected"
      @close="close"
    >
    </dept-picker>
  </div>
</template>

<script>
import DeptPicker from '@/components/common/DeptPicker'
import { createGroup, getFormGroups } from '@/api/oa_approve'
import pick from 'lodash.pick'
import { mapMutations } from 'vuex'
const fields = ['formName', 'groupId', 'category', 'remark']
export default {
  name: 'FormBaseSetting',
  components: { DeptPicker },
  props: {
    formData: {
      type: Object,
      default: () => undefined
    }
  },
  data () {
    return {
      form: this.$form.createForm(this, { name: 'FormBaseSettingForm' }),
      pickVisible: false,
      nowUserSelect: null,
      select: [],
      newGroup: '',
      fromGroup: [],
      categories: this.$Dictionaries.approval_category,
      category: '',
      selectedId: ''
    }
  },
  computed: {
    setup () {
      return this.$store.state.oaApprove.design
    },
    filterCategories () {
      return this.categories.filter(item => item.visible).map(item => {
        item.children = item.children.filter(c => c.visible)
        return item
      })
    }
  },
  mounted () {
    this.getGroups()
  },
  methods: {
    ...mapMutations('oaApprove', ['setDesignFormName', 'setDesignGroupId', 'setDesignCategory', 'setDesignRemark']),
    loadData () {
      if (this.formData) {
        this.$nextTick(() => {
          const groupId = this.$route.query.groupId
          const formDataInfo = {
            formName: this.formData.formName,
            groupId: this.formData.groupId ? this.formData.groupId : groupId === undefined || groupId === 'undefined' ? undefined : this.$route.query.groupId,
            category: this.formData.category === undefined ? undefined : this.formData.category.split(',').map(c => Number(c)),
            remark: this.formData.remark ? this.formData.remark : this.setup.remark
          }
          this.formData && this.form.setFieldsValue(pick(formDataInfo, fields))
        })
      }
    },
    reLoadData () {
      this.loadData()
    },
    getGroups () {
      getFormGroups().then(rsp => {
        this.fromGroup = rsp.data.entries
        if (this.fromGroup.length > 0) {
          this.loadData()
        }
      }).catch(err => this.$message.error('获取分组异常' + err))
    },
    addGroup () {
      if (this.newGroup.trim() !== '') {
        createGroup({ name: this.newGroup.trim() }).then(rsp => {
          if (rsp.code === 1000) {
            this.$message.success('创建成功')
          }
          this.getGroups()
        }).catch(err => this.$message.error(err.response.data))
      }
    },
    selected (select) {
      this.$set(this.setup.settings, this.nowUserSelect, select)
    },
    close () {
      this.pickVisible = false
    },
    selectUser (key) {
      this.select = this.setup.settings[key]
      this.nowUserSelect = key
      this.pickVisible = true
      // this.$refs.orgPicker.show()
    },
    validate () {
      const errors = []
      this.form.validateFields((err, values) => {
        if (err) {
          errors.push(err)
        } else {
          this.setDesignFormName(values['formName'])
          if (values['groupId']) {
            this.setDesignGroupId(values['groupId'])
          }
          if (values['remark']) {
            this.setDesignRemark(values['remark'])
          }
        }
      })
      return errors
    },
    onChange (value) {
      if (value !== undefined && value.length > 0) {
        // this.setup.category = value[value.length - 1]
        // this.$store.commit('setDesignCategory', value.join(','))
        this.setDesignCategory(value.join(','))
      }
    },
    displayRender ({ labels }) {
      return labels[labels.length - 1]
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-select-dropdown {
  display: none;
}

.icon-select {
  display: flex;
  flex-wrap: wrap;
  i {
    cursor: pointer;
    font-size: large;
    padding: 10px;
    max-width: 38px !important;
    &:hover {
      box-shadow: 0 0 10px 2px #C2C2C2;
    }
  }
}

/deep/ .select-u {
  width: 100%;
}

.base-setup {
  overflow: auto;
  width: 900px;
  background: #ffffff;
  margin: 10px auto 0;
  height: 60vh;
  padding: 15px 20px;
  border-radius: 5px;

  i:first-child {
    position: relative;
    cursor: pointer;
    font-size: xx-large;
    color: #ffffff;
    border-radius: 10px;
    padding: 10px;
  }

  .change-icon {
    margin-left: 20px;

    span {
      font-size: small;
      color: #7a7a7a;
      margin-right: 15px;
    }

    i {
      cursor: pointer;
      color: #7a7a7a;
      font-size: x-large;
    }
  }

  /deep/ .el-form-item__label {
    padding: 0;
    font-weight: bold;
  }

  /deep/ .el-form-item {
    margin-bottom: 5px;
  }
}

/deep/ .group {
  .el-select {
    width: calc(100% - 130px);
  }

  .el-button {
    margin-left: 10px;
    width: 120px;
  }
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: #f8f8f8;
}

::-webkit-scrollbar-thumb {
  border-radius: 16px;
  background-color: #e8e8e8;
}
</style>
